import React, { FunctionComponent, ReactElement } from "react";
import { useIntl } from "react-intl";
import { ReactComponent as IconCrop } from "./crop-bicolors.svg";
import { TemplateType } from "../../../../types/customization/template";
import ContentNotification from "../../../atoms/ContentNotification";
import TranslationByType from "../../customization/TranslationByType";
import ConfirmModalSmily from "../ConfirmModalSmily";
import "./style.scss";

interface Props {
  display: boolean;
  emptyPages?: string[];
  noCroppedPictures?: boolean;
  onConfirm: () => void;
  onDismiss: () => void;
  templateType?: TemplateType;
}

const RemainingActionsModal: FunctionComponent<Props> = ({
  display,
  emptyPages,
  noCroppedPictures = false,
  onConfirm,
  onDismiss,
  templateType,
}) => {
  const intl = useIntl();

  const hasEmptyPages = emptyPages && emptyPages.length > 0;
  const title = hasEmptyPages ? (
    <>
      {intl.formatMessage({ id: "kustom_RemainingActionsModal_title_wip_part1" })}
      <br />
      {intl.formatMessage({ id: "kustom_RemainingActionsModal_title_wip_part2" })}
    </>
  ) : (
    intl.formatMessage({ id: "kustom_RemainingActionsModal_title_crop" })
  );
  const confirmLabel = hasEmptyPages
    ? "kustom_RemainingActionsModal_button_modify"
    : "kustom_NoCroppedPictureModal_finished";
  const dismissLabel = hasEmptyPages
    ? "kustom_NoCroppedPictureModal_finished"
    : "kustom_RemainingActionsModal_button_modify";

  let emptyPagesTitle: ReactElement | undefined;
  let emptyPagesDetail;
  if (hasEmptyPages && templateType) {
    emptyPagesTitle = (
      <TranslationByType
        count={2}
        templateType={templateType}
        translationBase="kustom_RemainingActionsModal_blank_title"
      />
    );
    emptyPagesDetail =
      emptyPages && emptyPages.length > 3
        ? [...emptyPages, "…"].join(", ")
        : emptyPages?.join(", ");
  }

  return (
    <ConfirmModalSmily
      className="RemainingActionsModal"
      confirmLabel={intl.formatMessage({ id: confirmLabel })}
      dismissLabel={intl.formatMessage({ id: dismissLabel })}
      display={display}
      onConfirm={hasEmptyPages ? undefined : onConfirm}
      onDismiss={onDismiss}
      showDismissButton={!hasEmptyPages}
      type="information"
    >
      <>
        <div className="RemainingActionsModal-image">
          <IconCrop />
        </div>
        <h2 className="RemainingActionsModal-title">{title}</h2>
        <div className="RemainingActionsModal-content">
          {hasEmptyPages && (
            <ContentNotification title={emptyPagesTitle} type="error">
              {intl.formatMessage(
                { id: "kustom_RemainingActionsModal_blank_text" },
                { pageList: emptyPagesDetail }
              )}
            </ContentNotification>
          )}
          {noCroppedPictures && (
            <ContentNotification
              title={intl.formatMessage({ id: "kustom_RemainingActionsModal_crop_title" })}
              type="warning"
            >
              {intl.formatMessage({ id: "kustom_RemainingActionsModal_crop_text" })}
            </ContentNotification>
          )}
        </div>
      </>
    </ConfirmModalSmily>
  );
};

export default RemainingActionsModal;
